var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9504 15.5076C16.04 15.5076 15.2993 14.7669 15.2993 13.8566V11.1146C15.2993 10.2042 16.04 9.46358 16.9504 9.46358H21.2525C21.2785 9.46358 21.3044 9.46437 21.3302 9.46553V6.73411C21.3302 6.03101 20.7602 5.46104 20.0572 5.46104H4.27311C3.56997 5.461 3 6.03097 3 6.73407V18.2371C3 18.9402 3.56997 19.5102 4.27311 19.5102H20.0572C20.7602 19.5102 21.3302 18.9402 21.3302 18.2371V15.5056C21.3044 15.5068 21.2785 15.5076 21.2525 15.5076H16.9504Z",
    fill: "#182519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2536 10.3678H16.9515C16.5393 10.3678 16.2051 10.702 16.2051 11.1142V13.8561C16.2051 14.2683 16.5393 14.6025 16.9515 14.6025H21.2536C21.6658 14.6025 21.9999 14.2683 21.9999 13.8561V11.1142C21.9999 10.7019 21.6658 10.3678 21.2536 10.3678ZM18.4339 13.5623C17.8389 13.5623 17.3566 13.0801 17.3566 12.4851C17.3566 11.8901 17.8389 11.4079 18.4339 11.4079C19.0288 11.4079 19.5111 11.8901 19.5111 12.4851C19.5111 13.0801 19.0288 13.5623 18.4339 13.5623Z",
    fill: "#182519"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.84 3.12869C17.5552 2.26662 16.6254 1.79866 15.7634 2.08348L9.29582 4.22019H18.2006L17.84 3.12869Z",
    fill: "#182519"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.556479934abfeb0cdc12ef68e972b542.svg";
export { ForwardRef as ReactComponent };